import { type ReactNode } from 'react';
import { motion } from 'motion/react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  rounded?: 'sm' | 'md' | 'lg' | 'xl';
}

const Card = ({ 
  children, 
  className = '', 
  hover = false, 
  padding = 'md',
  rounded = 'lg'
}: CardProps) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const roundedClasses = {
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
  };

  const combinedClasses = `
    bg-white border border-gray-200 shadow-sm
    ${paddingClasses[padding]}
    ${roundedClasses[rounded]}
    ${hover ? 'transition-all duration-300 hover:shadow-xl cursor-pointer' : ''}
    ${className}
  `;

  return (
    <motion.div
      whileHover={hover ? { y: -5, scale: 1.02 } : {}}
      className={combinedClasses}
    >
      {children}
    </motion.div>
  );
};

export default Card;